import { __assign } from "tslib";
import React from "react";
import { Check } from "../check";
import { RadioGroup } from "./RadioGroup";
import { forwardRefWithStatics } from "../_util/forward-ref-with-statics";
export var Radio = forwardRefWithStatics(function (props, ref) {
    return React.createElement(Check, __assign({ ref: ref, type: "radio" }, props));
}, 
// statics
{
    Group: RadioGroup,
});
Radio.displayName = "Radio";
//# sourceMappingURL=Radio.js.map